export const REQUEST_STATUS: {
  initial: "INITIAL";
  success: "SUCCESS";
  failed: "FAILED";
  loading: "LOADING";
} = {
  initial: "INITIAL",
  success: "SUCCESS",
  failed: "FAILED",
  loading: "LOADING",
};
